/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemainingCoverage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RemainingCoverage({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/RemainingCoverage"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesMaxLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.max_lifetime_coverage',
})
let insuredTxCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'insured',
path: 'tx_category_insured.ortho_insured.used_lifetime_coverage',
})
let aggregateData = fromHelpers.getValue(insuredInsuranceSubscriptionInsurancePlanTxCategoryCoveragesOrthoCoveragesMaxLifetimeCoverageValueData, insuredTxCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData)
  return (<React.Fragment
>
<div
  data-testid="RemainingCoverage.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Remaining coverage"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.insurance_subscription.insurance_plan.tx_category_coverages.ortho_coverages.max_lifetime_coverage"
 data="insured.tx_category_insured.ortho_insured.used_lifetime_coverage"
 aggregate="helpers.js getValue"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}